import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/ourBoard";

export default class OurBoardService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
